import React, { useState, useEffect } from "react";
import "./Carousel.css";

const AttractionCarousel = ({ children }) => {
  const [counter, setCounter] = useState(1);
  const content = children;

  const handleNext = () => {
    if (counter !== content.length) {
      setCounter(counter + 1);
    } else {
      setCounter(1);
    }
  };

  const handlePre = () => {
    if (counter !== 1) {
      setCounter(counter - 1);
    } else {
      setCounter(content.length);
    }
  };

  const handlePage = (page) => {
    setCounter(page);
  };

  const handleMouse = () => {
    console.log("handleMouse called");
  };

  return (
    <div className="App">
      <div className="slide" onClick={handleMouse}>
        {content.map((item, index) => (
          <div
            className={counter - 1 === index ? "show" : "not-show"}
            key={index}
          >
            {item}
          </div>
        ))}

        <button className="attractions-prev" onClick={handlePre}>
          &#10094;
        </button>
        <button className="attractions-next" onClick={handleNext}>
          &#10095;
        </button>
      </div>

      <div className="page">
        {content.map((item, index) => (
          <span
            key={index}
            className={counter - 1 === index ? "dot active" : "dot"}
            onClick={() => handlePage(index + 1)}
          />
        ))}
      </div>
    </div>
  );
};

export default AttractionCarousel;
